import {React} from '@api'
import ProductCardPdf from '@modules/pdf/templates/ProductCardPdf'

import { pdfStylesStore} from '@modules/pdf'
import {VLPProductCardStore} from '@modules/pdf/templates/vlp/VLPProductCardStore'
import ReactPDF, {StyleSheet} from '@react-pdf/renderer'

export const productCardStyles = StyleSheet.create({
  productCard:  {
    ...pdfStylesStore,
    display: 'flex',
    flexDirection: 'column',
    alignSelf:'center',
    flexGrow: 0,
    flexShrink: 0,
    borderWidth: 1,
    borderRadius: 4,
    borderStyle: 'solid',
    borderColor: '#dedede',
    paddingTop: 0,
    paddingBottom: 0,
    width: 120,
    overflow: 'hidden',
    alignContent: 'center',
    justifyContent:'center',
  } as any,
  emptyProductImage: {
    width:  120,
    height: 120,
  },
  productImage: {
    width:  120,
    height: 120,
    maxWidth: '100%',
    objectFit: 'contain',
    marginBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#dedede',
    borderBottomStyle: 'solid',
    paddingBottom:     4,
  },
  productName: {
   fontSize: 12,
    fontWeight: 'bold',
    marginLeft:  'auto',
    marginRight: 'auto',
    textOverflow:'ellipsis',
  },
  subtitle: {
    fontSize: 8,
     fontWeight: 'bold',
     textOverflow:'ellipsis'
   },

  specs: {
    display:'flex',
    flexDirection: 'column',
    borderTopWidth: 1,
    borderTopColor: '#dedede',
    borderTopStyle: 'solid',
    paddingTop: 4,
    paddingRight:8,
    marginTop:  4,
  },

  specSwatch: {
    width:      20,
    height:     20,
    flexGrow:   0,
    flexShrink: 0,
  },
  specHex: {

  },
  specImage: {
    objectFit:    'contain',
    borderRadius: 2,
  } as any,

  specImagePlaceholder: {
    borderRadius: 0,
    borderWidth:1,
    borderStyle: 'solid',
    borderColor: '#dedede',
  } as any
}) as ReactPDF.Styles

export interface PdfProductCardRendererProps {
  data: any
  specs?
  imageUrl?: string
  style?: any
  download?: boolean
  store?: VLPProductCardStore
}



// WEBPACK FOOTER //
// ./src/modules/pdf/productCard/ProductCardPdf.tsx